import { useState, useCallback, useEffect, useRef, useDebugValue } from 'react';
import './Table3.css'


const createHeaders = (headers) => {
    return headers.map((item) => ({
        text: item.props.title,
        ref: useRef(),
    }));

}
export const Table4 = ({ dataSource, minCellWidth, children }) => {

    const [tableHeight, setTableHeight] = useState('auto');
    const [activeIndex, setActiveIndex] = useState(null);
    const tableElement = useRef(null);
    const columns1 = createHeaders(children);



    const mouseDown = (index) => {
        setActiveIndex(index);
    }

    const mouseMove = useCallback((e) => {
        // Return an array of px values
        const gridColumns = columns1.map((col, i) => {
            if (i === activeIndex) {
                // Calculate the column width
                const width = e.clientX - col.ref.current.offsetLeft;

                if (width >= minCellWidth) {
                    return `${width}px`;
                }
            }

            // Otherwise return the previous width (no changes)
            return `${col.ref.current.offsetWidth}px`;
        });

        // Assign the px values to the table
        tableElement.current.style.gridTemplateColumns = `${gridColumns.join(' ')}`;
    }, [activeIndex, columns1, minCellWidth]);

    const removeListeners = useCallback(() => {
        window.removeEventListener('mousemove', mouseMove);
        window.removeEventListener('mouseup', removeListeners);
    }, [mouseMove]);

    const mouseUp = useCallback(() => {
        setActiveIndex(null);
        removeListeners();
    }, [setActiveIndex, removeListeners]);



    useEffect(() => {
        setTableHeight(tableElement.current.offsetHeight);
    }, []);


    useEffect(() => {
        if (activeIndex !== null) {
            window.addEventListener('mousemove', mouseMove);
            window.addEventListener('mouseup', mouseUp);
        }

        return () => {
            removeListeners();
        }
    }, [activeIndex, mouseMove, mouseUp, removeListeners]);


    let gridTemplateColumns = '';
    columns1.map(x => gridTemplateColumns += 'minmax(150px, 1fr) ');


    return (
        <form className="table-wrapper">
            <table
                style={{ gridTemplateColumns: gridTemplateColumns }}
                className="resizeable-table" ref={tableElement}>
                <thead>
                    <tr>
                        {columns1.map(({ ref, text }, i) => (
                            <th ref={ref} key={i}>
                                <span>{text}</span>
                                <div
                                    style={{ height: tableHeight }}
                                    onMouseDown={() => mouseDown(i)}
                                    className={`resize-handle ${activeIndex === i ? 'active' : 'idle'}`}
                                />
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {dataSource.map((r, j) => {
                        return (<tr key={j}   >
                            {
                                children.map((x, i) => {
                                    let di = dataSource[j];
                                    let aa = (x.props.field && di[x.props.field]) ? di[x.props.field] : '-';
                                    let t = x.type.name;
                                    if (t == "ColInput")
                                        return <td {...x.props} key={i}>
                                            <input
                                                value={aa}
                                                onChange={e => x.props.onChange(e, j)}
                                                onKeyDown={e => { if (x.props.onKeyDown) x.props.onKeyDown(e, j) }}
                                                className="form-control" />
                                        </td>
                                    else if (t == "ColBtn")
                                        return <td {...x.props} key={i}>
                                            <input
                                                type="button"
                                                value={aa}
                                                onClick={e => { if (x.props.onClick) x.props.onClick(e, j) }}
                                                onKeyDown={e => { if (x.props.onKeyDown) x.props.onKeyDown(e, j) }}
                                                className="btn btn-outline-primary w-100" />
                                        </td>
                                    return <td {...x.props}>{aa}</td>
                                })
                            }
                        </tr>);
                    })}
                </tbody>

            </table>
        </form>
    );
}

export const Col = (props) => {
    return (
        <td {...props}> {props.children}  </td>
    );
}

export const ColInput = (props) => {
    return (
        <td {...props}> {props.children}  </td>
    );
}

export const ColBtn = (props) => {
    return (
        <td {...props}> {props.children}  </td>
    );
}